__turbopack_context__.v({
  "calloutSection": "PlasmicCapabilities-module__kCxRDG__calloutSection",
  "capTopSection": "PlasmicCapabilities-module__kCxRDG__capTopSection",
  "capabilitiesCards": "PlasmicCapabilities-module__kCxRDG__capabilitiesCards",
  "contactModal": "PlasmicCapabilities-module__kCxRDG__contactModal",
  "footer": "PlasmicCapabilities-module__kCxRDG__footer",
  "header": "PlasmicCapabilities-module__kCxRDG__header",
  "root": "PlasmicCapabilities-module__kCxRDG__root",
  "serviceMessage": "PlasmicCapabilities-module__kCxRDG__serviceMessage",
  "serviceMessageWrapper": "PlasmicCapabilities-module__kCxRDG__serviceMessageWrapper",
});
